import * as Yup from 'yup';

const MAX_FILES = 5;
const MAX_SIZE = 3 * 1024 * 1024; // 3MB in bytes

export const validationSchema = Yup.object().shape({
  client_ids: Yup.array()
    .of(Yup.number())
    .min(1, "At least one recipient is required")
    .required("Recipients are required"),
  subject: Yup.string().required("Subject is required"),
  body: Yup.string().required("Email content is required"),
  attachments: Yup.array()
    .of(
      Yup.mixed()
        .test("fileSize", "File size is too large", (value) => {
          if (value) {
            return value.size <= MAX_SIZE;
          }
          return true; // If no file, validation passes
        })
    )
    .max(MAX_FILES, `You can upload a maximum of ${MAX_FILES} files`),
});